import { createAction } from "redux-actions";
import { GET_STATES } from "../constants";
import { feathersFindDataAll } from "../services";

// export const transferRequest = createAction(TRANSFER_REQUEST, (data) => serverTransferRequest(urlTransferCodes, data)())
export const getStates = createAction(GET_STATES, () => feathersFindDataAll('states',{})())
